export default __webpack_public_path__ + "static/lalibrairie-jl-mobile-d284a1ab206c106e002b14fde1ac1923.jpg";